export const FLAGS_ROOT = '/admin/flags';

export const featureFlagDetailPath = ({ flagId }) => `${FLAGS_ROOT}/${flagId}`;

export const flagDetailRoute = featureFlagDetailPath({
  flagId: ':flagId',
});
